import React from "react";
import { Outlet, Navigate } from "react-router-dom";

const PublicEmptyLayout = ({ children }) => {

  return (
    <div className="empty-layout bg-grey-50">
      <Outlet/>
    </div>
  );
};

export default PublicEmptyLayout;
